export default "__VITE_ASSET__DkyMtTm0__"